import api from './api';

/**
 * Get available templates
 */
export const getTemplates = async () => {
  const response = await api.get('/templates');
  return response.data;
};

/**
 * Preview resume with a specific template
 * @param {Object} params - Preview parameters
 * @param {string} params.sessionId - Conversation session ID
 * @param {string} params.resumeId - Existing resume ID
 * @param {Object} params.content - Direct content object
 * @param {string} params.template - Template ID (traditional/modern/creative)
 */
export const previewTemplate = async ({ sessionId, resumeId, content, template }) => {
  const response = await api.post('/templates/preview', {
    sessionId,
    resumeId,
    content,
    template
  });
  return response.data;
};

/**
 * Get preview HTML for conversation content
 * @param {string} sessionId - Conversation session ID
 * @param {string} template - Template ID
 */
export const getConversationPreview = async (sessionId, template) => {
  const response = await api.post('/templates/conversation-preview', {
    sessionId,
    template
  });
  return response.data;
};

export default {
  getTemplates,
  previewTemplate,
  getConversationPreview
};
